import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', function() {
	const swiperEls = document.getElementsByClassName('sectionFeaturedProducts__swiper');

	if (!swiperEls.length) {
		return;
	}

	new Swiper('.sectionFeaturedProducts__swiper', {
		centeredSlides: false,
		loop: false,
		spaceBetween: 0,
		touchEventsTarget: 'container',
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: '.sectionFeaturedProducts__swiper-button-next',
			prevEl: '.sectionFeaturedProducts__swiper-button-prev',
		},
		breakpointsBase: 'container',
		breakpoints: {
			700: {
				slidesPerView: 2,
			},
			950: {
			  slidesPerView: 3,
			},
			1200: {
			  slidesPerView: 3,
			},
			1600: {
			  slidesPerView: 4,
			},
			2000: {
				slidesPerView: 5,
			},
			2400: {
				slidesPerView: 6,
			},
		},
		threshold: 2,
	});
});
